import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import {
  AppBar,
  Badge,
  Card,
  CardHeader,
  Stack,
  styled,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import MaterialBox from "../../components/MaterialBox";
import breakpoints from "../../assest/theme/base/breakpoints";
import UserDetailsContext from "../../context/auth";
import { Download } from "@mui/icons-material";

//CSS for material UI Badge
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: -6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const EmployeeManagement = () => {
  const navigate = useNavigate();
  const { user, AccessData, setEmpSubmit } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [userDetails, setUserDetails] = useState({
    department: "",
    designation: "",
    employeeType: "",
  });

  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState("activeUsers"); //Used to store current selected tab
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [tabs, setTabs] = useState([
    // {
    //     id: "all",
    //     name: "All",
    //     count: 1,
    // },
    {
      id: "employee",
      name: "Employee",
      count: 0,
    },
    {
      id: "manager",
      name: "Manager",
      count: 2,
    },
  ]); // Used to show tabs name and passing id to database

  useEffect(() => {
    fetchEmployeeUsers(tabValue);
  }, [tabValue]);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
    window.addEventListener("resize", handleTabsOrientation);
    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  function notificationsLabel(badgeContent) {
    if (badgeContent === 0) {
      return "no notifications";
    }
    if (badgeContent > 99) {
      return "more than 99 notifications";
    }
    return `${badgeContent} notifications`;
  }

  const activeUsersDetailQuery = `query activeUsersDetail{
      activeUsersDetail {
        id
        lastLogin
        username
        firstName
        lastName
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader
        grade
        role{
          role
        }
      }
    }`;

  const inactiveUsersDetailQuery = `query inactiveUsersDetail{
      inactiveUsersDetail {
        id
        lastLogin
        username
        firstName
        lastName
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader
        grade
        role{
          role
        }
      }
    }`;

  const fetchEmployeeUsers = async (status) => {
    const query =
      status === "inactiveUsers"
        ? inactiveUsersDetailQuery
        : activeUsersDetailQuery;
    const responseKey =
      status === "inactiveUsers" ? "inactiveUsersDetail" : "activeUsersDetail";

    try {
      setPageState((prev) => ({ ...prev, loading: true, error: false }));

      const response = await axios.post(
        BASEURL,
        { query },
        { headers: { "Content-Type": "application/json" } },
      );

      const userDetails = sessionStorage.getItem("user");
      const getDetails = JSON.parse(userDetails || "{}");
      setUserDetails({
        department: user?.department || getDetails.department || "",
        designation: user?.designation || getDetails.designation || "",
        employeeType: user?.employeeType || getDetails.employeeType || "",
      });

      const EmpList = response.data?.data?.[responseKey] || [];
      const filterdata = EmpList.filter((val) => val.empid !== "");
      setEmployeeList(filterdata);
      setPageState((prev) => ({ ...prev, loading: false, state: "success" }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState((prev) => ({
        ...prev,
        loading: false,
        error: true,
        message: error.message,
      }));
    }
  };

  // const onEmployeeeSubmit = async () => {
  //     const query = `query{
  //     allUsersDetail{
  //     id
  //     lastLogin
  //     username
  //     firstName
  //     lastName
  //     isActive
  //     dateJoined
  //     email
  //     salutation
  //     dateOfBirth
  //     contactNumber
  //     emergencyContact
  //     gender
  //     employeeType
  //     lastUpdate
  //     department
  //     designation
  //     empid
  //     teamleader
  //     grade
  //     role{
  //     role
  //     }
  //     }}`;

  //     try {
  //         setPageState({ ...pageState, loading: true });

  //         const response = await axios.post(BASEURL, {
  //             query: query
  //         }, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //         });

  //         const userDetails = sessionStorage.getItem('user')
  //         const getDetails = JSON.parse(userDetails)
  //         setUserDetails({
  //             department: user?.department || getDetails.department || "",
  //             designation: user?.designation || getDetails.designation || "",
  //             employeeType: user?.employeeType || getDetails.employeeType || ""
  //         })

  //         const EmpList = response.data.data.allUsersDetail;
  //         const filterdata = EmpList.filter((val)=> val.empid != "")
  //         setEmployeeList(filterdata);
  //         setPageState({ ...pageState, loading: false, state: 'success' });
  //     } catch (error) {
  //         console.error('ResponseError:', error);
  //         setPageState({ ...pageState, loading: false, error: true, message: error.message });
  //     }
  // };

  const handleExport = async () => {
    if (!selectedIds.length) return;

    const mutation = `
      mutation ExportEmployeeExcel($ids: [Int!]!) {
        exportEmployeeExcel(ids: $ids) {
          success
          message
          fileUrl
        }
      }
    `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: mutation,
          variables: { ids: selectedIds.map((id) => parseInt(id, 10)) },
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const result = response.data?.data?.exportEmployeeExcel;
      if (result?.success && result?.fileUrl) {
        const link = document.createElement("a");
        link.href = result.fileUrl;
        link.setAttribute("download", "Employees.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Export failed:", result?.message);
        alert(result?.message || "Export failed. Please try again.");
      }
    } catch (error) {
      console.error("Export error:", error);
      alert("Export failed. Please try again.");
    }
  };

  const handleSelectedIdsChange = (ids) => {
    setSelectedIds(ids);
  };

  const employeeListTable = {
    columns: [
      {
        field: "empid",
        headerName: "Employee Id",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "firstName",
        headerName: "First Name",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "lastName",
        headerName: "Last Name",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "contactNumber",
        headerName: "Contact Number",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "role",
        headerName: "Role",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "department",
        headerName: "Department",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "designation",
        headerName: "Designation",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      // {
      //     field: "teamleader",
      //     headerName: "Team leader",
      //     width: 150,
      //     disableColumnMenu: true,
      //     editable: false,
      //     sortable: true,
      // },
      // {
      //     field: "employeeType",
      //     headerName: "Employee Type",
      //     width: 150,
      //     disableColumnMenu: true,
      //     editable: false,
      //     sortable: true,
      // },
    ],

    rows: employeeList.map((performance) => ({
      id: performance.id,
      empid: performance?.empid,
      firstName: performance.firstName
        ? performance.firstName?.charAt(0).toUpperCase() +
          performance.firstName?.slice(1)
        : "",
      lastName: performance.lastName
        ? performance.lastName?.charAt(0).toUpperCase() +
          performance.lastName?.slice(1)
        : "",
      contactNumber: performance?.contactNumber,
      role: performance.role?.role,
      department: performance?.department,
      designation: performance?.designation,
    })),
  };

  const handleNewEmployee = () => {
    setEmpSubmit(false);

    navigate("/employee-management/add-employee");
  };

  const onEmployeeListClick = (e) => {
    console.log("eeeee:", e);
    setEmpSubmit(true);
    console.log("onEmployeeListClick:", e?.id, e);
    if (e?.id) {
      // navigate(`/employee-management/viewscreen?id=${e?.id}`)
      navigate(`/employee-management/add-employee?id=${e?.id}`);
    }
  };

  console.log("employeeList:", employeeList);

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium" sx={{whiteSpace: "noWrap"}}>
                  Employee Management List
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  List of employees and their details
                </MaterialTypography>
              </Stack>

              <MaterialBox alignItems="center" width="60%" justifyContent="center">
                <MaterialBox width="70%">
                  <AppBar position="static">
                    <Tabs
                      orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{ backgroundColor: "transparent" }}
                    >       
                      <Tab label="Active Users" value="activeUse6rs" />
                      <Tab label="Inactive Users" value="inactiveUsers" />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddEmployee" && item.can_access,
                ) && (
                  <Tooltip
                    title={
                      selectedIds.length === 0
                        ? "Select at least one employee to export"
                        : ""
                    }
                    arrow
                  >
                    <span>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        // sx={{ mr: 1 }}
                        onClick={handleExport}
                        startIcon={<Download/>}
                        disabled={selectedIds.length === 0}
                      >
                        Export
                      </MaterialButton>
                    </span>
                  </Tooltip>
                )}
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddEmployee" && item.can_access,
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEmployee()}
                  >
                    Employee
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={500}
          rows={employeeListTable.rows}
          columns={employeeListTable.columns}
          checkboxSelection={true}
          rowSelectionModel={selectedIds}
          onRowSelectionModelChange={handleSelectedIdsChange}
          isSelectable={true}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No employee found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any employee details. Click on the "Add
                  Employee" button to start adding employee details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default EmployeeManagement;
